const styles = () => ({
  fields: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '24px'
  }
})

export default styles
